import React from 'react';
import { Tabs } from 'antd';
import { inject, observer } from 'mobx-react';
import history from '../../routes/history'
import * as AppUrl from '../../constants/appUrl'
import ReportPage from '../reportPage';
import PbiReportPage from '../pbiReportPage'
import ReportManagement from '../reportManagement';
import ReportTag from '../reportTag';

@inject('routerStateModel', 'reportManagementStore', 'routerStateModel', 'accountStore')
@observer
class TabsManager extends React.Component {
  state = {
    activeKey: '',
    lastReportId: null, // 用于存储上一次的 reportId
  };

  componentDidMount() {
    const { routerStateModel, match } = this.props;
    const { urlHistory } = routerStateModel;
    
    // 如果urlHistory为空，说明刚清除了tab列表，需要重新初始化
    if (urlHistory.length === 0) {
      // 优先从URL参数获取id
      let reportId = null;
      let reportType = null;
      
      if (match && match.params && match.params.id) {
        reportId = match.params.id;
        // 根据当前路径判断reportType
        if (window.location.pathname.includes('pbiReportPage')) {
          reportType = 'pbiReportPage';
        } else {
          reportType = 'reportPage';
        }
      } else {
        // 向后兼容：从localStorage获取
        const selectedItem = localStorage.getItem('selectedItem');
        if (selectedItem) {
          const reportName = localStorage.getItem('defaultReportName');
          if(reportName == null){
            return
          }
          if(selectedItem?.includes('reportManagement')) {
            this.setState({ activeKey: selectedItem[0], lastReportId: selectedItem[0] });
            routerStateModel.addRoute({
              groupKey: 'reportManagement',
              pathname: '/reportManagement',
              id: 'reportManagement',
              name: '报表管理',
              component: 'ReportManagement'
            });
            return;
          } else if(selectedItem?.includes('reportTag')) {
            this.setState({ activeKey: selectedItem[0], lastReportId: selectedItem[0] });
            routerStateModel.addRoute({
              groupKey: 'reportTag',
              pathname: '/reportTag',
              id: 'reportTag',
              name: '报表标签',
              component: 'ReportTag'
            });
            return;
          } else {
            const [id, type] = selectedItem.split(',');
            reportId = id;
            reportType = type;
          }
        }
      }

      // 如果没有reportId，根据当前路径设置默认值
      if (!reportId) {
        if (window.location.pathname.includes('reportManagement')) {
          reportId = 'reportManagement';
          reportType = 'reportManagement';
        } else if (window.location.pathname.includes('reportTag')) {
          reportId = 'reportTag';
          reportType = 'reportTag';
        } else if (window.location.pathname.includes('pbiReportPage')) {
          reportId = 'pbiReportPage';
          reportType = 'pbiReportPage';
        } else {
          reportId = 'reportPage';
          reportType = 'reportPage';
        }
      }

      if (reportId) {
        if (reportId === 'reportManagement') {
          this.setState({ activeKey: reportId, lastReportId: reportId });
          routerStateModel.addRoute({
            groupKey: 'reportManagement',
            pathname: '/reportManagement',
            id: 'reportManagement',
            name: '报表管理',
            component: 'ReportManagement'
          });
        } else if (reportId === 'reportTag') {
          this.setState({ activeKey: reportId, lastReportId: reportId });
          routerStateModel.addRoute({
            groupKey: 'reportTag',
            pathname: '/reportTag',
            id: 'reportTag',
            name: '报表标签',
            component: 'ReportTag'
          });
        } else {
          this.setState({ activeKey: reportId, lastReportId: reportId });
          // 需要获取报表详情来设置名称
          this.props.reportManagementStore.getReportDetail(reportId).then(() => {
            const { tabsInfo } = this.props.reportManagementStore;
            const componentType = reportType === 'pbiReportPage' ? 'PbiReportPage' : 'ReportPage';
            routerStateModel.addRoute({
              groupKey: Number(reportId),
              pathname: '/report',
              id: Number(reportId),
              name: tabsInfo.name,
              component: componentType
            });
          });
        }
      }
    } else {
      // 如果urlHistory不为空，使用原有的逻辑
      // 优先从URL参数获取id
      let reportId = null;
      let reportType = null;
      
      if (match && match.params && match.params.id) {
        reportId = match.params.id;
        // 根据当前路径判断reportType
        if (window.location.pathname.includes('pbiReportPage')) {
          reportType = 'pbiReportPage';
        } else {
          reportType = 'reportPage';
        }
      } else {
        // 向后兼容：从localStorage获取
        const selectedItem = localStorage.getItem('selectedItem');
        if (selectedItem) {
          const reportName = localStorage.getItem('defaultReportName');
          if(reportName == null){
            return
          }
          if(selectedItem?.includes('reportManagement')) {
            this.setState({ activeKey: selectedItem[0], lastReportId: selectedItem[0] });
            routerStateModel.addRoute({
              groupKey: 'reportManagement',
              pathname: '/reportManagement',
              id: 'reportManagement',
              name: '报表管理',
              component: 'ReportManagement'
            });
            return;
          } else if(selectedItem?.includes('reportTag')) {
            this.setState({ activeKey: selectedItem[0], lastReportId: selectedItem[0] });
            routerStateModel.addRoute({
              groupKey: 'reportTag',
              pathname: '/reportTag',
              id: 'reportTag',
              name: '报表标签',
              component: 'ReportTag'
            });
            return;
          } else {
            const [id, type] = selectedItem.split(',');
            reportId = id;
            reportType = type;
          }
        }
      }

      // 如果没有reportId，根据当前路径设置默认值
      if (!reportId) {
        if (window.location.pathname.includes('reportManagement')) {
          reportId = 'reportManagement';
          reportType = 'reportManagement';
        } else if (window.location.pathname.includes('reportTag')) {
          reportId = 'reportTag';
          reportType = 'reportTag';
        } else if (window.location.pathname.includes('pbiReportPage')) {
          reportId = 'pbiReportPage';
          reportType = 'pbiReportPage';
        } else {
          reportId = 'reportPage';
          reportType = 'reportPage';
        }
      }

      if (reportId) {
        if (reportId === 'reportManagement') {
          this.setState({ activeKey: reportId, lastReportId: reportId });
          routerStateModel.addRoute({
            groupKey: 'reportManagement',
            pathname: '/reportManagement',
            id: 'reportManagement',
            name: '报表管理',
            component: 'ReportManagement'
          });
        } else if (reportId === 'reportTag') {
          this.setState({ activeKey: reportId, lastReportId: reportId });
          routerStateModel.addRoute({
            groupKey: 'reportTag',
            pathname: '/reportTag',
            id: 'reportTag',
            name: '报表标签',
            component: 'ReportTag'
          });
        } else {
          this.setState({ activeKey: reportId, lastReportId: reportId });
          // 需要获取报表详情来设置名称
          this.props.reportManagementStore.getReportDetail(reportId).then(() => {
            const { tabsInfo } = this.props.reportManagementStore;
            const componentType = reportType === 'pbiReportPage' ? 'PbiReportPage' : 'ReportPage';
            routerStateModel.addRoute({
              groupKey: Number(reportId),
              pathname: '/report',
              id: Number(reportId),
              name: tabsInfo.name,
              component: componentType
            });
          });
        }
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { match } = this.props;
    
    // 优先从URL参数获取id
    let currentReportId = null;
    if (match && match.params && match.params.id) {
      currentReportId = match.params.id;
    } else {
      // 向后兼容：从localStorage获取
      const selectedItem = localStorage.getItem('selectedItem');
      if (selectedItem) {
        currentReportId = selectedItem.split(',')[0];
      }
    }
    
    // 比较当前的 reportId 和之前的 reportId
    if (currentReportId && currentReportId !== this.state.lastReportId) {
       this.setState({ activeKey: currentReportId, lastReportId: currentReportId });
    }
  }

  onChange = (key) => {
    const { reportManagementStore, routerStateModel, accountStore } = this.props;
    const { reportMenus } = reportManagementStore
    const { urlHistory } = routerStateModel;
    accountStore.onMenuClick([key])
    // accountStore.reportFetchFlagChange()
    // 判断该菜单是否已经存在于标签中。
    const isTab = urlHistory?.filter(a=>a?.id.toString()===key)?.length > 0 ? true : false
    accountStore.setIsTabHas(isTab)
    console.log('key', key)
    if(key==='reportManagement') {
      accountStore.setSeletedItem(key)
      accountStore.setReportName('报表管理')
      // 更新localStorage
      localStorage.setItem('selectedItem', key);
      history.push(AppUrl.REPORTMANAGEMENT)
    } else if(key==='reportTag') {
      accountStore.setSeletedItem(key)
      accountStore.setReportName('报表标签')
      // 更新localStorage
      localStorage.setItem('selectedItem', key);
      history.push(AppUrl.REPORTTAG)
    } else {
      const reportType = reportMenus?.find(a=>a?.id===parseInt(key))?.type
      const typeString = reportType==="PowerBI" ? 'pbiReportPage' : 'reportPage'
      accountStore.setSeletedItem([key, typeString])
      // 更新localStorage
      localStorage.setItem('selectedItem', `${key},${typeString}`);
      reportManagementStore.getReportDetail(key)     
      .then(() => {
        const { tabsInfo } = reportManagementStore
        accountStore.setReportName(tabsInfo.name)
        
        if (reportType.includes('pbiReportPage')) {
          history.push(`${AppUrl.PBIREPORTPAGE}/${key}`)
        } else {
          history.push(`${AppUrl.REPORTPAGE}/${key}`)
        }
      })
    }
    this.setState({ activeKey: key });
  };

  onEdit = (targetKey, action) => {
    if (action === 'remove') {
      this.removeTargetKey(targetKey);
    }
  };

  removeTargetKey = (targetKey) => {
    const { routerStateModel } = this.props;
    const { urlHistory } = routerStateModel;
  
    const urlIndex = urlHistory.findIndex(item => item.id.toString().trim() === targetKey.toString().trim());
    if (urlIndex !== -1) {
      const newActiveKey = String(this.determineNextActiveKey(urlHistory, urlIndex));

      if (newActiveKey == "null" ){
                    return;
      }
      routerStateModel.closeCurrentTag(urlIndex);
      this.setState({ activeKey: newActiveKey }, () => {
        this.onChange(newActiveKey); // 手动触发切换逻辑
      });
      return;
    }
  };

  determineNextActiveKey = (history, removedIndex) => {
    if (history.length === 0) {
      // 如果没有标签页了，可以设置一个默认的 activeKey 或者不设置
      return null;
    }

    let newActiveKey;
    if (removedIndex === 0) {
      // 如果关闭的是第一个标签页，切换到第二个标签页
      newActiveKey = history.length > 1 ? history[1].id : null;
    } else if (removedIndex === history.length - 1) {
      // 如果关闭的是最后一个标签页，切换到前一个标签页
      newActiveKey = history[history.length - 2].id;
    } else {
      // 如果关闭的是中间的标签页，切换到下一个标签页
      newActiveKey = history[removedIndex + 1].id;
    }

    return newActiveKey;
  };

  // 根据组件名称渲染对应组件
  renderComponent = (componentName, menu, location) => {
    switch (componentName) {
      case 'ReportManagement':
        return <ReportManagement key={menu.id} location={location}/>;
      case 'ReportTag':
        return <ReportTag key={menu.id} location={location}/>;
      case 'PbiReportPage':
        return <PbiReportPage key={menu.id} reportName={menu.name} reportId={menu.id} location={location}/>;
      case 'ReportPage':
        return <ReportPage key={menu.id} reportName={menu.name} reportId={menu.id} type="reportPage" location={location}/>;
      default:
        return <ReportPage key={menu.id} reportName={menu.name} reportId={menu.id} type="reportPage" location={location}/>;
    }
  };

  render() {
    const { routerStateModel, location, match } = this.props;
    const { urlHistory } = routerStateModel;
    
    // 如果urlHistory为空，不显示任何tab
    if (urlHistory.length === 0) {
      return null;
    }

    // 直接循环渲染队列中的组件
    const menuItems = urlHistory.map(menu => (
      <Tabs.TabPane tab={menu.name} key={menu.id} closable={urlHistory.length !== 1}>
        {this.renderComponent(menu.component, menu, location)}
      </Tabs.TabPane>
    ));

    return (
      <Tabs
        size="small"
        type="editable-card"
        hideAdd
        onChange={this.onChange}
        onEdit={this.onEdit}
        className='reportTabs'
        activeKey={this.state.activeKey}
      >
        {menuItems}
      </Tabs>
    );
  }
}

export default TabsManager;